(function() {
	'use strict';

	angular.module('quantixApp').controller('IndustryLevelAlertController',
			IndustryLevelAlertController);

	IndustryLevelAlertController.$inject = [ '$scope', '$stateParams',
			'$filter', '$rootScope', '$timeout', 'companyData',
			'$uibModalInstance', 'CompanyIndAlertService', 'AlertService',
			'parentAccess', '$window', 'GenericService' ];

	function IndustryLevelAlertController($scope, $stateParams, $filter,
			$rootScope, $timeout, companyData, $uibModalInstance,
			CompanyIndAlertService, AlertService, parentAccess, $window,
			GenericService) {
		$scope.flagForIndustrySub = false;
		$scope.errorCompInfo = false;
		
		var sectionaccess = {};
		GenericService.getUserSectionAccessData().then(function(result){
			sectionaccess=result;
			if (sectionaccess["Industry Profile.Industry Level Alert"] != 'Y') {
				$scope.errorCompInfo = true;
				$scope.flagForIndustrySub = true;
				$scope.errorMessageCompInfo = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
	
			}
		});

		

		$scope.getIndustryAlertDetails = function() {

			var indAlertData = {
				industryId : companyData.industryId,
				isIndustryLevel : companyData.isIndustryLevel,
				portFolioID : companyData.portFolioId,
				isPortFolioLevel : companyData.isPortfolioLevel
			};

			CompanyIndAlertService.getIndustryLevelAlertDetais(indAlertData)
					.then(function(data) {
						if (data.length != 0) {
							$scope.industryLevelAlertDetails = data[0];
						} else {
							$uibModalInstance.dismiss('cancel');
						}

					}, function(errordata) {
					});

		}

		$scope.changeInIndustryRisk = function() {

			if ($scope.industryLevelAlertDetails.isIndustryRisk == 'N') {
				$scope.industryLevelAlertDetails.isIndustryRiskUpgrade = 'N';
				$scope.industryLevelAlertDetails.isIndustryRiskDowngrade = 'N';
			} else if ($scope.industryLevelAlertDetails.isIndustryRisk == 'Y') {

				$scope.industryLevelAlertDetails.isIndustryRiskUpgrade = 'Y';
				$scope.industryLevelAlertDetails.isIndustryRiskDowngrade = 'N';
			}
		}

		$scope.changeInIndustryRiskInnerFunction = function() {

			if ($scope.industryLevelAlertDetails.isIndustryRiskUpgrade == 'Y'
					|| $scope.industryLevelAlertDetails.isIndustryRiskDowngrade == 'Y') {
				$scope.industryLevelAlertDetails.isIndustryRisk = 'Y';
			} else if ($scope.industryLevelAlertDetails.isIndustryRisk == 'Y'
					&& $scope.industryLevelAlertDetails.isIndustryRiskUpgrade == 'N'
					&& $scope.industryLevelAlertDetails.isIndustryRiskDowngrade == 'N') {
				$scope.industryLevelAlertDetails.isIndustryRisk = 'N';
				$scope.industryLevelAlertDetails.isIndustryRiskDowngrade = 'N';
				$scope.industryLevelAlertDetails.isIndustryRiskUpgrade = 'N';
			}

		}

		$scope.changeInIndustryMedianRating = function() {
			if ($scope.industryLevelAlertDetails.isMedianRating == 'N') {
				$scope.industryLevelAlertDetails.isMedianRatingUpgrade = 'N';
				$scope.industryLevelAlertDetails.isMedianRatingDowngrade = 'N';
			} else if ($scope.industryLevelAlertDetails.isMedianRating == 'Y') {
				$scope.industryLevelAlertDetails.isMedianRatingUpgrade = 'Y';
				$scope.industryLevelAlertDetails.isMedianRatingDowngrade = 'N';
			}

		}

		$scope.changeInIndustryMedianRatingInnerFunction = function() {
			if ($scope.industryLevelAlertDetails.isMedianRatingUpgrade == 'Y'
					|| $scope.industryLevelAlertDetails.isMedianRatingDowngrade == 'Y') {
				$scope.industryLevelAlertDetails.isMedianRating = 'Y';
			} else if ($scope.industryLevelAlertDetails.isMedianRating == 'Y'
					&& $scope.industryLevelAlertDetails.isMedianRatingUpgrade == 'N'
					&& $scope.industryLevelAlertDetails.isMedianRatingDowngrade == 'N') {
				$scope.industryLevelAlertDetails.isMedianRating = 'N';
				$scope.industryLevelAlertDetails.isMedianRatingDowngrade = 'N';
				$scope.industryLevelAlertDetails.isMedianRatingUpgrade = 'N';
			}
		}

		$scope.saveIndustryAlertData = function() {
			if ($window
					.confirm("Are you sure you want to Set Alert for this Industry ?")) {
				if (companyData.industryName != undefined
						&& companyData.industryName != '') {
					$scope.industryLevelAlertDetails.industryName = companyData.industryName;
				}
				CompanyIndAlertService
						.setIndustryLevelAlert($scope.industryLevelAlertDetails)
						.then(
								function(result) {
									if (result.isSuccess == 'true') {
										$scope.issuccess = true;
										$scope.error = false;
										$scope.successMessages = result.message;
										parentAccess.setIndAlertStatus = true;
										parentAccess.alertAction = 'Remove Alert';
										parentAccess.industryLevelAlertFlag = false;
									} else {
										$scope.error = true;
										$scope.issuccess = false;
										$scope.errorMessages = result.message;
									}
									$timeout(function() {
										$uibModalInstance.dismiss('cancel');
									}, 1000);
								},
								function(response, status, headers, config) {
									$scope.error = true;
									$scope.errorMessages = "Error occured while setting Alert"
									$timeout(function() {
										$uibModalInstance.dismiss('cancel');
									}, 1000);

								});

			} else {
				$uibModalInstance.dismiss('cancel');
			}
		}

		$scope.defaultAlertData = function() {
			$scope.industryLevelAlertDetails = {
				name : 'Industry Alert',
				industryId : companyData.industryId,
				portFolioId : companyData.portFolioId,
				isIndustryLevel : companyData.isIndustryLevel,
				isPortfolioLevel : companyData.isPortfolioLevel,
				isCompanyLevel : companyData.isCompanyLevel,
				isIndustryCompanyLevel : companyData.isIndustryCompanyLevel,
				isPortfolioCompanyLevel : companyData.isPortfolioCompanyLevel,
				isIndustryRisk : 'Y',
				isIndustryRiskUpgrade : 'Y',
				isIndustryRiskDowngrade : 'N',
				isMedianRating : 'Y',
				isMedianRatingUpgrade : 'Y',
				isMedianRatingDowngrade : 'N',

			};

			if ($scope.flagForIndustrySub) {
				$scope.industryLevelAlertDetails.isIndustryRisk = 'N';
				$scope.industryLevelAlertDetails.isIndustryRiskUpgrade = 'N';
				$scope.industryLevelAlertDetails.isIndustryRiskDowngrade = 'N';
				$scope.industryLevelAlertDetails.isMedianRating = 'N';
				$scope.industryLevelAlertDetails.isMedianRatingUpgrade = 'N';
				$scope.industryLevelAlertDetails.isMedianRatingDowngrade = 'N';
			}

		}

		$scope.cancel = function() {
			$uibModalInstance.dismiss('cancel');

		}

		$scope.dynamicClassChange = function(value) {
			if ('Y' == value) {
				return "fa fa-plus-circle pull-right block font-green-meadow";
			} else if ('N' == value) {
				return "fa fa-minus-circle pull-right block font-green-meadow";
			}

		}
		$scope.getIndustryAlertDetails();

	}
})();